import React, { ReactNode } from 'react';

import './index.less';

import { ElmaCortexFullLogo } from '../../../assets';
import IbMainMenu from '../IbMainMenu';
import { getDefaultIfUndefined } from '../../../utils/typeUtil';

const CHAT_SELECTED_DEFAULT = false;

const MAIN_CLASS_NAME = 'ib-sider';
const CHAT_SELECTED_CLASS_NAME = `${MAIN_CLASS_NAME}_chat-selected`;
const LOGO_CLASS_NAME = `${MAIN_CLASS_NAME}__logo`;
const MENU_CLASS_NAME = `${MAIN_CLASS_NAME}__menu`;
const ACCOUNT_CLASS_NAME = `${MAIN_CLASS_NAME}__account`;
const APP_VERSION_CLASS_NAME = `${MAIN_CLASS_NAME}__app-version`;

interface IIbSiderProps {
  selectedItem: string;
  chatSelected?: boolean;
  accountWidget?: ReactNode;
  appVersion?: ReactNode;
  onGoToMainPage: () => void;
}

const IbSider: React.FC<IIbSiderProps> = ({
  accountWidget,
  appVersion,
  chatSelected,
  onGoToMainPage,
  selectedItem,
}) => {
  chatSelected = getDefaultIfUndefined(chatSelected, CHAT_SELECTED_DEFAULT);

  return (
    <div className={`${MAIN_CLASS_NAME} ${chatSelected ? CHAT_SELECTED_CLASS_NAME : ''}`}>
      <div className={LOGO_CLASS_NAME}>
        <ElmaCortexFullLogo onClick={onGoToMainPage} />
      </div>
      <div className={MENU_CLASS_NAME}>
        <IbMainMenu selectedItem={selectedItem} />
      </div>
      <div className={ACCOUNT_CLASS_NAME}>{accountWidget}</div>
      <div className={APP_VERSION_CLASS_NAME}>{appVersion}</div>
    </div>
  );
};

export default IbSider;
